
<template>
  <div class="yxtbiz-rank-list" v-loading="loading">
    <div
      v-if="!Object.keys(configData).length"
      class="yxtbiz-rank-list__empty"
      :style="{ height: height ? height + 'px' : 'auto' }"
    >
      <div v-if="initFlag < 2">
        <yxtf-empty
          size="small"
          :empty-text="$t('pc_biz_lbl_nodata').d('暂无数据')"
        ></yxtf-empty>
      </div>
    </div>
    <div v-else>
      <one-column
        :height="height"
        :rankData="rankData"
        v-if="styleType === 1"
        ref="rankList"
        :errorTip="errorTip"
        :initFlag="initFlag"
        @changeDate="changeDate"
        ><div slot="title"><slot name="title"></slot></div
      ></one-column>
      <two-columns
        :height="height"
        :rankData="rankData"
        :errorTip="errorTip"
        :initFlag="initFlag"
        ref="rankList"
        v-else
        @changeDate="changeDate"
        ><div slot="title"><slot name="title"></slot></div
      ></two-columns>
    </div>
  </div>
</template>

<script>
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
import oneColumn from './onecolumn';
import twoColumns from './twocolumns';
import {
  dictionaryKeys,
  objectName,
  attributeName,
  primaryCode,
  rankName,
  emptyTip
} from './config';
export default {
  name: 'YxtbizRankList',
  components: {
    oneColumn,
    twoColumns
  },
  props: {
    // 榜单配置信息 -- rankId 榜单ID(必填); templateType 模版类型: 0 机构模版、1 平台模版; showTop  展示Top
    rankConfig: {
      type: Object,
      default: () => ({ rankId: '', templateType: 1 })
    },
    // 展示样式: 1 列表式、2 横排式
    showStyle: {
      type: Number
    },
    // 样式类型: 1 一列式、2 两列式
    styleType: {
      type: Number,
      default: 1
    },
    // 隐藏头部（包含标题、时间筛选、部门筛选等）
    hideHeader: {
      type: Boolean,
      default: false
    },
    // 隐藏标题
    hideTitle: {
      type: Boolean,
      default: false
    },
    // 隐藏我的排名
    hideMyRank: {
      type: Boolean,
      default: false
    },
    // 排行榜高度
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      configData: {}, // 榜单配置
      contentObj: {
        hasHead: false,
        primaryCode: '',
        secondaryCodes: [],
        attributeCode: '',
        attributeName: '',
        objectName: '',
        objectCode: '',
        type: 1
      }, // 榜单内容配置
      rankData: {}, // 榜单数据
      titleObj: {
        title: '',
        type: 1,
        showTop: 0,
        attributeName: '',
        objectCode: '',
        showDate: false,
        defaultDateType: 1,
        dateArr: []
      }, // 榜单名称配置
      loading: false, // 加载中
      apiError: 0, // 获取榜单数据的接口报错 1 计算中 2 其他报错
      initFlag: 2 // 记录是否调用过接口
    };
  },
  provide() {
    return {
      contentFun: () => this.contentObj,
      styleFun: () => ({
        styleType: this.styleType,
        showStyle: this.showStyle || this.configData.rankStyle,
        hideTitle: this.hideTitle,
        hideHeader: this.hideHeader,
        hideMyRank: this.hideMyRank
      }),
      titleFun: () => this.titleObj
    };
  },
  watch: {
    rankConfig: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  computed: {
    // 排行榜错误文案
    errorTip() {
      let tip = '';
      switch (this.apiError) {
        case 0:
          tip = emptyTip[this.configData.objectCode];
          break;
        case 1:
          tip = 'pc_biz_rank_calculating'; // 正在计算排行数据，稍后刷新
          break;
        case 2:
          tip = 'pc_biz_lbl_nodata'; // 暂无数据
          break;
      }
      return tip;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化榜单
    async init() {
      if (this.rankConfig.rankId) {
        this.initFlag = 2;
        this.getRankConfig();
      }
    },
    // 获取榜单配置
    async getRankConfig() {
      const id = this.rankConfig.rankId;
      try {
        this.loading = true;
        const templateType = this.rankConfig.templateType
          ? Number(this.rankConfig.templateType)
          : 1;
        const data = await apiBaseUrl.get(
          `/rank/rankdata/${this.rankConfig.rankId}/config?templateType=${templateType}`
        );
        if (id === this.rankConfig.rankId) {
          this.initFlag--;
          this.configData = data;
          this.getRankList();
          this.formatData();
        }
      } catch (err) {
        if (id === this.rankConfig.rankId) {
          this.loading = false;
          this.initFlag--;
          this.configData = {};
          err &&
            err.error &&
            err.error.message &&
            this.$message.error(err.error.message);
        }
      }
    },
    // 获取榜单数据
    async getRankList(dateType) {
      const id = this.rankConfig.rankId;
      try {
        const limit =
          this.rankConfig.showTop > 0
            ? this.rankConfig.showTop
            : this.configData.rankTop;
        const params = {
          id,
          offset: 0,
          limit,
          dateType: dateType || this.configData.defaultDateType,
          showTop: this.configData.rankTop,
          templateType: this.rankConfig.templateType
            ? Number(this.rankConfig.templateType)
            : 1
        };
        const data = await apiBaseUrl.post('/rank/rankdata', params);
        if (id === this.rankConfig.rankId) {
          if (data.cleanStatus === 1 || data.rankList) {
            this.apiError = 0;
            this.rankData = data;
          } else {
            this.apiError = 1;
          }
          this.initFlag--;
          this.height &&
            this.$refs.rankList &&
            this.$refs.rankList.scrollToTop();
          this.loading = false;
        }
      } catch (err) {
        if (id === this.rankConfig.rankId) {
          this.rankData = {};
          this.loading = false;
          this.initFlag--;
          this.apiError =
            err && err.error && err.error.code === 20010012 ? 1 : 2;
          err &&
            err.error &&
            err.error.message &&
            this.$message.error(err.error.message);
        }
      }
    },
    // 格式化数据
    formatData() {
      // 榜单内容配置
      let showContent = this.configData.rankContent || [];
      const contentObj = {
        hasHead: false,
        primaryCode: primaryCode[this.configData.objectCode],
        secondaryCodes: [],
        attributeCode: this.configData.dimensionCode,
        attributeName:
          attributeName[this.configData.objectCode][
            this.configData.dimensionCode
          ],
        objectCode: this.configData.objectCode,
        objectName: this.$t(objectName[this.configData.objectCode])
      };
      contentObj.hasHead = showContent.some(
        s => s === dictionaryKeys.userImgUrl || s === dictionaryKeys.deptImg
      );
      showContent = showContent.filter(
        s =>
          s !== dictionaryKeys.userImgUrl &&
          s !== dictionaryKeys.deptImg &&
          s !== primaryCode[this.configData.objectCode] &&
          s !== this.configData.dimensionCode
      );

      showContent.length && (contentObj.secondaryCodes = showContent);
      this.contentObj = contentObj;
      // 榜单名称配置
      this.titleObj = {
        title: this.$t(rankName[this.configData.dimensionCode]),
        attributeName:
          attributeName[this.configData.objectCode][
            this.configData.dimensionCode
          ],
        objectCode: this.configData.objectCode,
        showTop: this.configData.rankTop,
        showDate: true,
        defaultDateType: this.configData.defaultDateType,
        dateArr: this.configData.dateType
      };
    },
    // 日期更改时
    changeDate(type) {
      this.titleObj = { ...this.titleObj, defaultDateType: type };
      this.loading = true;
      this.getRankList(type);
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-rank-list {
  width: 100%;

  .yxtbiz-rank-list__empty {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
